import { trackHelpEvent } from 'actions/tracker/tracker';
import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import type { MouseEventHandler } from 'react';
import { useDispatch } from 'store/configureStore';
import { useTranslations } from 'utils/translations/useTranslations';

type HelpComponentProps = {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
} & FlysiteUrls;

const HelpComponent = ({ supportUrl, onClick }: HelpComponentProps) => {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const handleClick: MouseEventHandler<HTMLAnchorElement> = evt => {
    dispatch(trackHelpEvent());
    onClick?.(evt);
  };

  return (
    <a
      href={supportUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      data-testid="HelpLink"
    >
      {i18n.t('step.aside.help')}
    </a>
  );
};

const Help = WithFlysiteUrls(HelpComponent);

export { Help };
